module.exports = __webpack_public_path__ + "static/img/element_01.ce16f7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/element_01.png
// module id = Sg/x
// module chunks = 24